<template>
    <div class="main-search-container" :class="{'fill-height-while-loading': loading}">

        <div class="search-loading-container" v-if="loading">
            <div class="col-12 justify-content-center loading-spinner">
                <div class="spinner-border" role="status">
                    <span class="sr-only">{{ translate.home.loading }}...</span>
                </div>
                <span>{{ translate.home.loading }}...</span>
            </div>
        </div>

        <ModalPunterLoginOrRegisterComponent></ModalPunterLoginOrRegisterComponent>
        <modal-save-search ref="modalSaveSearch"></modal-save-search>

        <div class="row full-white-bg" :class="{'visibility-hidden': loading}">
            <div class="col-md-12">
                <search-component
                    ref="searchComp"
                    @mobileFilterOpened='filterOpened()'
                    @onSearchClick='cancelFilters()'
                    @saveSearch="saveSearch"
                ></search-component>
            </div>
        </div>

        <div class="row full-white-bg" :class="{'visibility-hidden': loading}">
            <div class="col-md-12">
                <div id="filter-wrapper">
                    <div class="filter-navigation">
                        <div class="filter-content-entry-mobile-title">
                            <a href="#" class="btn btn-rebrand-grey-outline btn-rebrand-xxs px-2" id="filter-cancel"
                               @click.prevent="cancelFilters()">{{ translate.home.cancel }}</a>
                            <a href="#" class="btn btn-rebrand-black btn-rebrand-xxs ml-auto px-2"
                               @click.prevent="clearAllFilters()">{{ translate.home.clearAll }}</a>

                            <div class="filter-content-entry-mobile-details">
                                <span>{{ translate.home.filter }}</span>
                                <p>{{ translate.home.filterDescription }}</p>
                            </div>
                        </div>
                        <div class="filter-navigation-entry hide-on-desktop" data-target-tab="location"
                             @click.prevent="filterOpened()">
                            <span class="title">{{ translate.home.location }}</span>
                        </div>
                        <div class="filter-navigation-entry" data-target-tab="price" @click.prevent="filterOpened()"
                             v-if="false">
                            <span class="title">{{ translate.home.price }}</span>
                            <span class="selected-options" v-if="priceTemp && priceTemp.length && priceTemp.length === 2">
                                <span v-for="entry in getFirstItemWithCount(getFlairPriceText(priceTemp))">{{entry}}</span>
                            </span>
                        </div>
                        <div class="filter-navigation-entry" data-target-tab="features" @click.prevent="filterOpened()">
                            <span class="title">{{ translate.home.features }}</span>
                            <span class="selected-options" v-if="featuresTemp && Object.keys(featuresTemp).length">
                                <span v-for="entry in getFirstItemWithCount(getFlairFeaturesTextMobile(featuresTemp))">{{entry}}</span>
                            </span>
                        </div>
                        <div class="filter-navigation-entry" data-target-tab="services" @click.prevent="filterOpened()">
                            <span class="title">{{ translate.home.services }}</span>
                            <span class="selected-options" v-if="servicesTemp && servicesTemp.length && allServices">
                                <span v-for="entry in getFirstItemWithCount(getFlairServiceTextMobile(servicesTemp))">{{entry}}</span>
                            </span>
                        </div>
                        <div class="filter-navigation-entry" data-target-tab="category" @click.prevent="filterOpened()">
                            <span class="title">{{ translate.home.categories }}</span>
                            <span class="selected-options" v-if="categoryTemp">
                                <span v-for="entry in getFirstItemWithCount(getFlairCategoryTextMobile(categoryTemp))">{{entry}}</span>
                            </span>
                        </div>
                        <div class="filter-navigation-entry" data-target-tab="extraContent"
                             @click.prevent="filterOpened()">
                            <span class="title">{{ translate.home.extraContent }}</span>
                            <span class="selected-options" v-if="extraContentTemp">
                                <span v-for="entry in getFirstItemWithCount(getFlairExtraContentTextMobile(extraContentTemp))">{{entry}}</span>
                            </span>
                        </div>
                    </div>

                    <div class="filter-container">
                        <div class="filter-content">

                            <!-- Location -->
                            <search-filter-location-component ref="filterLocation"/>

                            <!-- Price -->
                            <search-filter-price-component/>

                            <!-- Services -->
                            <search-filter-services-component/>

                            <!-- Features -->
                            <search-filter-features-component/>

                            <!-- Category -->
                            <search-filter-category-component/>

                            <!-- Extra content -->
                            <search-filter-extra-content-component/>

                        </div>

                        <div class="filter-controls">
                            <a href="#" class="btn btn-rebrand-primary" id="filter-show-results"
                               @click.prevent="showResults()">{{ translate.home.showResults }}
                                ({{ formatResultsTotal(foundUserCount) }})
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row full-white-bg under-search-bar--container" :class="{'visibility-hidden': loading}">
            <div class="col-md-12 under-search-bar--content">
                <toggle-gender-filter @gender-changed="onGenderFilterChanged"></toggle-gender-filter>
                <toggle-gallery-filter @click.native.prevent="toggleOnlyPrivateGallerySearch"></toggle-gallery-filter>
                <ToggleSexChatFilterComponent v-if="!lodash.has(regionData, 'sectionsToHide.sexChatFilter')"
                                              @click.native.prevent="toggleOnlySexChatSearch"></ToggleSexChatFilterComponent>

                <div class="btn-save-search d-none d-sm-block" v-if="isVipPunter" @click="saveSearch">
                    <p class="mb-0">
                        {{ translate.account.saveSearch }}
                        <icon-component :icon="fa_bell()"></icon-component>
                    </p>
                </div>

                <div class="d-sm-none search-results-count--mobile-container">
                    <p class="mb-0 search-results-count--mobile" v-if="searchResponse.total" e2e-id="search-results-count">
                        {{ formatResultsTotal(searchResponse.total) }}
                        {{ translate.home.searchResults }} <span v-if="hasActiveFilters">({{ translate.home.filtered }})</span>
                    </p>
                    <p class="mb-0 search-results-count--mobile" v-if="searchResponse.total === 0" e2e-id="search-results-count">
                        {{ translate.home.searchResultsZero }}
                    </p>

                    <button v-if="hasActiveFilters" @click="clearAllFiltersAndRefresh()"
                            class="btn-clear-filters">
                        {{ translate.home.clearFilters }}
                    </button>

                    <div class="btn-save-search" v-if="isVipPunter" @click="saveSearch">
                        <p class="mb-0">
                            {{ translate.account.saveSearch }}
                            <icon-component :icon="fa_bell()"></icon-component>
                        </p>
                    </div>
                </div>

                <div class="d-none justify-content-between flex-row position-relative">
                    <div e2e-id="search-sort-dropdown">
                        <div class="select-with-fa-icon offset-on-mobile search-order-by">
                            <select class="form-control minimal" v-model="sortBy" @change="getData(false)">
                                <option disabled hidden selected value="false">{{ translate.home.sortBy }}</option>
                                <option v-if="location && location.isCurrentLocation"
                                        value="nearest">{{ translate.home.sortNearest }}
                                </option>
                                <option value="last_login">{{ translate.home.sortLastOnline }}</option>
                                <option value="price_max">{{ translate.home.sortHighLow }}</option>
                                <option value="price_min">{{ translate.home.sortLowHigh }}</option>
                            </select>
                        </div>

                        <!-- This is needed for sort select width calculation -->
                        <div class="select-with-fa-icon search-order-by--width-reference">
                            <select class="form-control minimal">
                                <option>{{ translate.home.sortBy }}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <saved-search-new-escorts-component
            @onDistanceClick="onDistanceClick"
        ></saved-search-new-escorts-component>

        <div class="row profile-block-wrap profile-block-wrap--main main-search-results-container" :class="{'visibility-hidden': loading}">

            <template v-for="(object, key) in renderObjectsList">
                <!-- Ad components are keyed by page + position so pagination recreates
                     them: a reused instance keeps its already-fired (and deduped)
                     impression observer, silently skipping tracking on page 2+. -->
                <HardcodedAdvertsInSearchComponent v-if="object.isHardcodedAdvert" data-type="hardcoded"
                                                   :key="`hardcoded-${searchResponse.current_page}-${key}`"
                                                   :ad-type="object.hardcodedAdvert"></HardcodedAdvertsInSearchComponent>

                <visitx-in-search-component v-else-if="object.isVisitXAd" data-type="visitx"
                                            :key="`visitx-${searchResponse.current_page}-${key}`"
                                            :advert="object"></visitx-in-search-component>

                <susi-live-in-search-component v-else-if="object.isSusiLive" data-type="susi"
                                               :key="`susi-${searchResponse.current_page}-${key}`"
                                               :advert="object"></susi-live-in-search-component>

                <strip-chat-in-search-component v-else-if="object.isStripChat" data-type="stripchat"
                                                :key="`stripchat-${searchResponse.current_page}-${key}`"
                                                :advert="object"></strip-chat-in-search-component>

                <native-ad-in-search-component v-else-if="object.isNativeAd" data-type="native" :current-page="searchResponse.current_page"
                                               :key="`native-${searchResponse.current_page}-${key}`"
                                               :advert="object"></native-ad-in-search-component>

                <solad-in-search-component v-else-if="object.isSolAd" data-type="solad"
                                           :key="`solad-${searchResponse.current_page}-${key}`"
                                           :advert="object"></solad-in-search-component>

                <advert-in-search-component
                    v-else-if="object.isInterstitialCmsAdvert"
                    :advert="object.interstitialCmsAdvert"
                    :key="`advert-${key}`">
                </advert-in-search-component>

                <template v-else>
                    <premium-escort-component
                        v-if="isGoldUser(object)"
                        :key="`escort-${object.id}`"
                        :userProp="object"
                        @onDistanceClick="onDistanceClick"
                        @onUserClick="setTrackingSearchResultType('regular'); setLocalStorage(object);"
                    ></premium-escort-component>

                    <regular-escort-component
                        v-if="!isGoldUser(object)"
                        :key="`escort-${object.id}`"
                        :userProp="object"
                        @onDistanceClick="onDistanceClick"
                        @onUserClick="setTrackingSearchResultType('regular'); setLocalStorage(object);"
                    ></regular-escort-component>
                </template>

            </template>

        </div>

        <similar-escorts-component
            @onDistanceClick="onDistanceClick"
        ></similar-escorts-component>

        <PaginationComponent v-if="searchResponse.last_page > 1"
                             :currentPage="searchResponse.current_page"
                             :lastPage="searchResponse.last_page"
                             :class="{'visibility-hidden': loading}"
                             wrapperClass="pagination-container"
                             v-on:changePage="changePage"
        ></PaginationComponent>

        <div class="row main-search-location-description"
             :class="{'visibility-hidden': loading}"
             v-if="location && location.description" v-html="location.description"></div>

    </div>
</template>

<script>
import api from '@/core/api';
import jQueryLogic from "@/scripts/searchFilterJQuery";
import debounce from 'debounce';
import urlMixin from '../mixins/url-mixin.js';
import priceFlairMixin from '../mixins/flairs/price-flairs-mixin';
import servicesFlairMixin from '../mixins/flairs/services-flairs-mixin';
import categoryFlairMixin from '../mixins/flairs/category-flairs-mixin';
import featuresFlairMixin from '../mixins/flairs/features-flairs-mixin';
import seoUrl from '../mixins/seoUrls.js';
import photoMixin from "@/components/mixins/photoMixin";
import userMixin from "@/components/mixins/userMixin";
import SimilarEscortsComponent from "@/components/search/partials/SimilarEscortsComponent";
import RegularEscortViewComponent from "@/components/search/partials/RegularEscortViewComponent";
import PremiumEscortViewComponent from "@/components/search/partials/PremiumEscortViewComponent";
import xtrackingMixin from '../mixins/xtrackingMixin.js';
import lazyLoadImg from "@/components/mixins/lazyLoadImg";
import ModalSaveSearchResultsComponent from "@/components/search/partials/ModalSaveSearchResultsComponent";
import SavedSearchNewEscortsComponent from "@/components/search/partials/SavedSearchNewEscortsComponent";
import AdvertsInSearchComponent from "@/components/search/partials/AdvertsInSearchComponent";
import SoladInSearchComponent from "@/components/search/partials/adverts/SoladInSearchComponent";
import NativeAdInSearchComponent from "@/components/search/partials/adverts/NativeAdInSearchComponent";
import VisitxInSearchComponent from "@/components/search/partials/adverts/VisitxInSearchComponent";
import StripChatSearchComponent from "@/components/search/partials/adverts/StripChatSearchComponent";
import SusiLiveSearchComponent from "@/components/search/partials/adverts/SusiLiveSearchComponent";
import Utils from "@/core/utils";
import TogglePrivateGalleryFilterComponent from "@/components/search/partials/TogglePrivateGalleryFilterComponent.vue";
import ToggleSexChatFilterComponent from "@/components/search/partials/ToggleSexChatFilterComponent.vue";
import ToggleGenderFilterComponent from "@/components/search/partials/ToggleGenderFilterComponent.vue";
import HardcodedAdvertsInSearchComponent
    from "@/components/search/partials/adverts/HardcodedAdvertsInSearchComponent.vue";
import extraContentFlairsMixin from "@/components/mixins/flairs/extra-content-flairs-mixin";
import {advertSlots} from "@/core/utils/helpers/Adverts/advertSlots";
import {shouldShowStories} from "@/core/utils/helpers/seo/seoHelpers";
import {getCookie} from "@/core/utils/helpers/cookieHelper";
import {searchLocationPayload} from "@/core/utils/helpers/search/searchLocationPayloadHelper";
import CookiesEnum from "@/core/constants/cookiesEnum";
import {googleTagManager} from "@/core/utils/helpers/googleTagManager";
import {fa_angle_down, fa_bell} from "@/core/constants/icons";
import IconComponent from "@/components/global/IconComponent.vue";
import ModalPunterLoginOrRegisterComponent from "@/components/global/ModalPunterLoginOrRegisterComponent.vue";
import PaginationComponent from "@/components/partials/PaginationComponent.vue";
import {isBrazilRegion, isUnitedKingdomRegion} from "@/core/utils/helpers/regions/regionUrlHelper";

const data = () => {
    return {
        lodash: _,
        store: $store,
        debounceDelay: 400,
        unSubscribe: null,
        pageKey: 0,
        foundUserCount: 0,
        storiesFetchInitialized: false,
        user_location: null,
        currentLocationError: false,
        sortBy: false,
        loading: true,
        dataFetchingIsDone: false,
        noPhotoUrl: constants.user_photo.NO_PHOTO_SEARCH_URL,

        /**
         * to modify adverts
         * @see resources/js/components/search/partials/adverts/HardcodedAdvertsInSearchComponent.vue:4
         */
        hardcodedAdverts: [
            'StripChat',
            'SolAds',
        ],
        solAds: [],
        stripChat: [],
        susiLive: [],
    }
};

function created() {
    this.fetchTmpCountDebounced = debounce(this.fetchTmpCountDebounced, this.debounceDelay);
    this.isDesktop = utils.isDesktop();
    advertSlots.setIsDesktop(this.isDesktop);

    this.getData = debounce(this.getData, this.debounceDelay);

    if (typeof eventBus !== 'undefined') {
        eventBus.on('loadRek', () => {
            if (this.searchResponse.current_page === 1) {
                this.fetchSolAds();
                this.fetchSusiLive();
                this.fetchStripChat();
            }
        });
    }

    this.modifyRegionHardcodedAdverts();
}

async function mounted() {
    this.unSubscribe = this.store.subscribe((mutation) => {
        if (mutation.type === 'refreshSearch') {
            this.getData(mutation.payload);
        }

        if (mutation.type === 'setLoading') {
            this.loading = mutation.payload;
        }
    });

    this.$nextTick(jQueryLogic);

    window.addEventListener('popstate', this.onURLChange);

    if (window.location.hash || this.store.getters.getSearchDoneFromHome) {
        const fromLocalStorage = await this.changeUrl();
        if (fromLocalStorage) {
            this.dataFetchingIsDone = true;
            this.stopLoading();

            // set the last search id for screen view tracking
            if (typeof xt !== 'undefined' && _.get(this, 'searchResponse.request.id')) {

                // if the data comes from the local storage most likely it was triggered by the back button on the browser,
                // and it means we want to track a dynamic page view
                xpv(this.currentUser, null, 'search', {
                    sch: _.get(this, 'searchResponse.request.id'),
                });

                // set the last search id for the following dynamic page views to make sure it gets attached
                xt.setId('sch', _.get(this, 'searchResponse.request.id'));
            }

            this.fetchSearchStories();
            this.fetchSolAds();
            this.fetchSusiLive();
            this.fetchStripChat();
        } else {
            await this.getData(false, this.getPageFromUrlHash());
        }
    } else {
        if (typeof sessionStorage !== "undefined") {
            if (sessionStorage.getItem('savedSearchId')) {
                await this.getData(false);
            }
        }

        this.foundUserCount = _.get(this, 'searchResponse.total', 0);
        this.dataFetchingIsDone = true;
        this.stopLoading();
        this.fetchSearchStories();
        googleTagManager.sendSearchResultsLoadedEvent(this.foundUserCount);
        this.$nextTick(this.trackSearchSate);
    }
}

function changePage(page) {
    this.loading = true;

    this.store.commit('setSearchResponse', {
        users: null,
        total: null,
        current_page: page,
        last_page: _.get(this, 'searchResponse.last_page', 1),
        request: null,
    });
    window.scrollTo(0, 0);
    this.getData(false, page);
}

async function getData(changeUrl = true, page) {
    this.loading = true;
    this.dataFetchingIsDone = false;

    let path = this.$route.fullPath;

    if (changeUrl) {
        path = await this.generateUrl();

        if (this.getViewType() !== 'search') {
            return;
        }
    }

    if (page) {
        path = this.addPageToUrlPath(path, page);
    }

    if (!_.isEqual(this.$route.fullPath, path)) {
        this.$router.push({path: path});
    }

    let payload = {
        location: searchLocationPayload(this.location),
        price: this.price,
        features: this.features,
        services: this.services,
        is_venue: this.venue,
        is_asia: this.asia,
        category: this.category,
        extraContent: this.extraContent,
        sortBy: this.defineSortBy(),
        page: page || 1,
        search_radius: this.searchRadius,
        isIndependentEscortCategory: _.get(this.category, 'isIndependentEscortCategory', null),
    };

    const savedSearchId = sessionStorage.getItem('savedSearchId');
    if (savedSearchId) {
        sessionStorage.removeItem('savedSearchId');
        payload.savedSearchId = savedSearchId;
    }

    // the payload callback here is necessary to append the `gender = 'Weiblich'` filter
    // without modifying the current URL or UI.
    // It can't be done at the backend level only because we still need
    // to support `Alle` (All genders) case which does not get represented in the URL also.
    // Primary adjustment has been done at the `SeoRepository->getProfileOrSearchResults` level
    // which is another place where results get loaded, however, the `getData` call
    // here gets executed right after the Seo repository results comes back in the case when
    // the user comes from the homepage (getSearchDoneFromHome).
    //
    // So it means we actually have two places where data get loaded and that's why
    // we need two adjustments (the `SearchFilterFeaturesComponent` applies gender filter to the filter list UI)
    //
    // See also:
    // 1) `SearchFilterFeaturesComponent->mounted` (`features.gender = 'Weiblich'`)
    // 2) `SeoRepository->getProfileOrSearchResults`
    payload = this.defaultGenderPayloadCallback(payload);

    const [err, response] = await to(
        api.search.getEscortsByLocation(payload)
    );

    if (err) {
        this.onFailure();
    }

    this.store.commit('setSimilarEscorts', _.map(_.get(response, 'data.similar_escorts.hits', []), '_source'));
    this.store.commit('setSavedSearchNewEscorts', _.map(_.get(response, 'data.escortsFromSavedSearch.users.hits', []), '_source'));

    if (_.get(response, "data.users.total.value", 0)) {
        let users = response.data.users;
        let count = _.get(users, 'total.value', 0);

        if (count) {
            const lastPage = _.get(response, 'data.last_page', 1)

            this.store.commit('setSearchResponse', {
                total: _.get(users, 'total.value', 0),
                users: _.map(users.hits, '_source'),
                current_page: _.get(response, 'data.current_page', 1),
                last_page: lastPage,
                request: _.get(response, 'data.request'),
            });

            this.foundUserCount = _.get(users, 'total.value', 0); // For filter on init page

            if (lastPage < page) {
                path = this.addPageToUrlPath(path, lastPage);
                if (!_.isEqual(this.$route.fullPath, path)) {
                    this.$router.push({path: path});
                }
            }

            if (_.get(this, 'user_location.lat') && _.get(this, 'user_location.lon')) {
                this.calculateDistanceToUser(this.user_location.lat, this.user_location.lon);
            }
        }

    } else {
        this.store.commit('setSearchResponse', {
            total: 0,
            users: [],
            current_page: 1,
            last_page: 1,
            request: _.get(response, 'data.request'),
        });
        this.foundUserCount = 0
    }

    this.dataFetchingIsDone = true;
    this.pageKey++;
    this.stopLoading();

    if (!page || page === 1) {
        googleTagManager.sendSearchResultsLoadedEvent(this.foundUserCount);
    }

    $('#app-ssr').show();
    this.$nextTick(() => {
        this.trackSearchSate(page);
    });

    this.fetchSearchStories();
    this.fetchSolAds();
    this.fetchSusiLive();
    this.fetchStripChat();
}

async function fetchTmpCountDebounced() {
    this.foundUserCount = null;

    if (!Object.keys(this.locationTemp).length) {
        return;
    }

    const payload = {
        location: searchLocationPayload(this.locationTemp),
        price: this.priceTemp,
        features: this.featuresTemp,
        services: this.servicesTemp,
        category: this.categoryTemp,
        extraContent: this.extraContentTemp,
        sortBy: this.defineSortBy(),
        search_radius: this.searchRadiusTemp,
        onlyCount: true,
        isIndependentEscortCategory: _.get(this.categoryTemp, 'isIndependentEscortCategory', null),
    };

    const [err, response] = await to(
        api.search.getEscortsByLocation(payload)
    );

    if (err) {
        this.onFailure();
    }

    if (_.get(response, "data.users", false)) {
        let users = response.data.users;
        this.foundUserCount = _.get(users, 'total.value', 0);
    }
}

function showResults() {
    this.store.commit('setCategory', _.cloneDeep(this.categoryTemp));
    this.store.commit('setServices', _.cloneDeep(this.servicesTemp));
    this.store.commit('setPrice', _.cloneDeep(this.priceTemp));
    this.store.commit('setLocation', _.cloneDeep(this.locationTemp));
    this.store.commit('setFeatures', _.cloneDeep(this.featuresTemp));
    this.store.commit('setSearchRadius', _.cloneDeep(this.searchRadiusTemp));
    this.store.commit('setExtraContent', _.cloneDeep(this.extraContentTemp));

    this.store.commit('refreshSearch', true);
    this.store.commit('setFilterOpened', false);

    this.loading = true;
    this.clearAllFilters();
    window.scrollTo(0, 0);
}

function getFirstItemWithCount(content) {
    if (!content || typeof content !== 'string') {
        return [];
    }

    const items = content.split(', ');

    if (items.length === 0) {
        return [];
    }

    if (items.length === 1) {
        return [items[0]];
    }

    return [items[0], `+${items.length - 1}`];
}

function cancelFilters() {
    $('#close-filter-search').trigger('close');
    this.store.commit('setFilterOpened', false);
    this.clearAllFilters();
}

async function onURLChange() {
    this.loading = true;
    this.dataFetchingIsDone = false;

    await this.changeUrl();
    await this.getData(false, this.getPageFromUrlHash());
    this.fetchSolAds();
    this.fetchSusiLive();
    this.fetchStripChat();
}

function fetchCurrentLocationData() {
    return new Promise((resolve, rejected) => {
        if (!_.get(navigator, 'geolocation', false)) {
            this.onLocationError();
            return rejected(new Error('Geo location isn`t available'));
        }
        navigator.geolocation.getCurrentPosition(
            position => {
                const lat = _.get(position, 'coords.latitude', '');
                const lon = _.get(position, 'coords.longitude', '');
                resolve({lat, lon});
            },
            positionError => {
                this.onLocationError();
                return rejected(new Error('Geo location isn`t available'));
            },
            {enableHighAccuracy: true}
        );
    })
}

function defineSortBy() {
    const isCurrentLocation = _.get(this, 'location.isCurrentLocation', false);
    if (isCurrentLocation && this.sortBy === false) {
        this.sortBy = 'nearest';
        if (!this.user_location) {
            this.getCurrentLocation();
        }
    }
    if (!isCurrentLocation && (this.sortBy === false || this.sortBy === 'nearest')) {
        this.sortBy = 'last_login';
    }
    return this.sortBy;
}

function onFailure() {
    this.foundUserCount = null;
    return toastr.error(this.translate.home.errorCommon);
}

function calculateDistanceToUser(lat, lon) {
    if (lat && lon) {

        let tmpUsers = _.cloneDeep(this.searchResponse.users);
        let tmpSimilar = _.cloneDeep(this.similarEscorts);

        _.forEach(tmpUsers, user => {
            this.updateUserDistance(user, lat, lon);
        });

        _.forEach(tmpSimilar, user => {
            this.updateUserDistance(user, lat, lon);
        });

        this.store.commit('setSearchResponse', {
            total: this.searchResponse.total,
            users: tmpUsers,
            current_page: _.get(this, 'searchResponse.current_page', 1),
            last_page: _.get(this, 'searchResponse.last_page', 1),
            request: _.get(this, 'searchResponse.request'),
        });

        this.store.commit('setSimilarEscorts', tmpSimilar);
    }
}

function onDistanceClick() {
    if (this.user_location) {
        this.calculateDistanceToUser(this.user_location.lat, this.user_location.lon);
        return;
    }
    this.getCurrentLocation();
}

async function getCurrentLocation() {
    const [err, data] = await to(this.fetchCurrentLocationData());
    if (!err) {
        this.user_location = {lat: data.lat, lon: data.lon};
        this.onDistanceClick();
    }
}

function updateUserDistance(user, lat, lon) {
    user.distance = utils.calculateDistance(lat, lon, user.lat, user.lon);
}

function onLocationError() {
    this.currentLocationError = true;
    toastr.error(this.translate.home.currentLocationError);
}

function clearAllFilters() {
    this.$children.forEach(child => {
        if (typeof child.clearAllFilters === 'function') {
            child.clearAllFilters();
        }
    });
}

function clearAllFiltersAndRefresh() {
    this.store.commit('setCategory', {});
    this.store.commit('setServices', []);
    this.store.commit('setPrice', []);
    this.store.commit('setFeatures', {});
    this.store.commit('setExtraContent', {});
    this.store.commit('setSearchOnlyWithPrivateGallery', false);

    this.clearAllFilters();
    this.store.commit('refreshSearch', true);
}

function onGenderFilterChanged(gender) {
    let features = _.cloneDeep(this.features) || {};
    features.gender = gender;
    this.store.commit('setFeatures', features);
    this.store.commit('setFeaturesTemp', features);

    this.store.commit('refreshSearch', true);
}

function filterOpened() {
    this.store.commit('setFilterOpened', true);
    if (Utils.isMobile()) {
        window.history.pushState({}, '');
        window.isFilterModalActive = true;
    }
}

function stopLoading() {
    if (this.dataFetchingIsDone && _.get(this, 'allServices', []).length > 0) {
        this.loading = false;
    }
}

function setLocalStorage(user) {
    this.setSearchDataToLocalStorage();
    if (!_.isEqual(this.$route.fullPath, user.profile_path)) {
        this.$router.push({path: user.profile_path});
    }
}

function defaultGenderPayloadCallback(payload) {
    // if the features.gender is present we don't want to modify the payload
    // `payload.features.gender === null` identifies that the ALL genders have been selected
    if (payload.features && (payload.features.gender || payload.features.gender === null)) {
        return payload;
    }
    // payload references to the Vuex store
    let payloadObj = _.cloneDeep(payload);

    if (!payloadObj.features) {
        payloadObj.features = {};
    }

    payloadObj.features.gender = 'Weiblich';

    return payloadObj;
}

function trackSearchSate() {
    let mapper = (user, index) => {
        return {
            id: user.id,
            username: user.username,
            // the position index should start from 1 instead of 0
            position: index + 1,
            profile_type: (user.premium ? 'premium' : (user.plus_status ? 'plus' : null))
        }
    };

    let searchResponse = _.cloneDeep(this.searchResponse);
    let similarEscortData = _.cloneDeep(this.similarEscorts);
    let similarResults = null;

    searchResponse.users = this.renderObjectsList
        .filter(object => !object.isHardcodedAdvert && !object.isInterstitialCmsAdvert)
        .map(mapper);

    if (typeof similarEscortData != 'undefined' && similarEscortData !== null && similarEscortData.length) {
        similarResults = similarEscortData.map(mapper);
    }

    let attributes = {
        req: searchResponse.request,
        res: searchResponse.users,
        t: searchResponse.total,
        p: searchResponse.current_page,
        sim: similarResults,
    };

    if (typeof xps !== 'undefined') {
        xps(this.currentUser, attributes);
    }
}

function saveSearch() {
    this.$refs.modalSaveSearch.saveSearch();
}

async function fetchSearchStories() {
    if (!this.storiesFetchInitialized) {
        this.storiesFetchInitialized = true;
    } else if (!this.showStoriesCookieSet && getCookie(CookiesEnum.SHOW_STORIES) === 'true') {
        this.store.commit('setShowStoriesCookieSet', true);
    }

    if (!shouldShowStories(this.regionData, this.showStoriesCookieSet)) {
        return;
    }

    const areaSlug = _.get(this, 'location.slug', null);
    const areaId = _.get(this, 'location.id', null);

    const [err, response] = await to(
        api.stories.search(areaSlug, areaId, this.searchRadius),
    );

    const stories = _.get(response, 'data.results.stories', []);

    this.store.commit('setSearchStories', err ? [] : stories);
}

async function fetchSolAds() {
    const adsCount = _.sumBy(this.renderObjectsList, u => u.isSolAd ? 1 : 0);
    const soladAdvertSlots = this.renderObjectsList.filter(u => u.isSolAd);

    /**
     * THIS IS SO WRONG
     * we cannot stop fetching adverts eather with zero,
     * because then vue don't re-render component and advert impression tracking not working
     */
    // // Don't make API call if count is 0
    // if (!adsCount) {
    //     this.solAds = [];
    //     return;
    // }

    if (this.hideExplicitRegionAds) {
        this.solAds = _.times(adsCount, this.getDefaultPlaceholderForAds);

        return;
    }

    const nativeAdsIds = _.map(_.filter(this.renderObjectsList, u => u.isNativeAd), ad => ad.id);

    // Don't make API call if count is 0
    if (!adsCount) {
        this.solAds = [];
        return;
    }

    const [err, response] = await to(
        api.search.solads(adsCount, window.location.pathname, nativeAdsIds.join(',')),
    );

    const ads = _.get(response, 'data.results.advert', []);

    if (ads.length) {
        /**
         * Merge slot metadata (isSolAd, color, position) with actual ad data (id, imageurl, title, advertSize)
         * advertSize from API is critical for correct styling on frontend
         */
        this.solAds = _.zipWith(soladAdvertSlots, ads, _.merge);

        /**
         * Mark real ads as isDefault: false so template can distinguish
         * real ads from placeholder images (placeholder has isDefault: true)
         */
        this.solAds = this.solAds.map(function (advert) {
            // A slot without a matching ad (API returned fewer ads than slots) has no
            // imageurl — keep it as the default placeholder.
            if (advert.imageurl && !advert.imageurl.includes('placeholder')) {
                advert.isDefault = false;
            }
            return advert;
        });

        return this.solAds;
    }

    this.solAds = _.times(adsCount, this.getDefaultPlaceholderForAds);
}

async function fetchSusiLive() {
    const adsCount = _.sumBy(this.renderObjectsList, u => u.isSusiLive ? 1 : 0);

    /**
     * THIS IS SO WRONG
     * we cannot stop fetching adverts eather with zero,
     * because then vue don't re-render component and advert impression tracking not working
     */
    // // Don't make API call if count is 0
    // if (!adsCount) {
    //     this.susiLive = [];
    //     return;
    // }

    if (this.hideExplicitRegionAds) {
        this.susiLive = _.times(adsCount, this.getDefaultPlaceholderForAds);

        return;
    }

    const [err, response] = await to(
        api.search.susiLive(adsCount),
    );

    const ads = _.get(response, 'data.results', []);

    if (ads.length) {
        return this.susiLive = ads;
    }

    this.susiLive = _.times(adsCount, this.getDefaultPlaceholderForAds);
}

async function fetchStripChat() {
    const adsCount = _.sumBy(this.renderObjectsList, u => u.isStripChat ? 1 : 0);

    /**
     * THIS IS SO WRONG
     * we cannot stop fetching adverts eather with zero,
     * because then vue don't re-render component and advert impression tracking not working
     */
    // // Don't make API call if count is 0
    // if (!adsCount) {
    //     this.stripChat = [];
    //     return;
    // }

    if (this.hideExplicitRegionAds) {
        this.stripChat = _.times(adsCount, this.getDefaultPlaceholderForAds);

        return;
    }

    // Send gender to backend for tag determination
    const gender = _.get(this.features, 'gender', null);
    const [err, response] = await to(
        api.search.stripChat(adsCount, gender),
    );

    const ads = _.get(response, 'data.results', []);

    if (ads.length) {
        return this.stripChat = ads;
    }

    this.stripChat = _.times(adsCount, this.getDefaultPlaceholderForAds);
}

function getDefaultPlaceholderForAds() {
    return {
        imageurl: "/images/soladaplaceholder.jpg",
        isDefault: true,
    };
}

function modifyRegionHardcodedAdverts() {
    if (isBrazilRegion()) {
        this.hardcodedAdverts = this.hardcodedAdverts.filter(hardcodedAdvert => hardcodedAdvert !== 'SolAds');
    }
}

function formatResultsTotal(total) {
    if (_.isNull(total)) {
        return '...';
    }

    if (!isUnitedKingdomRegion() && parseInt(total) >= 10000) {
        return '15000+';
    }

    return total;
}

export default {
    data,
    created,
    mixins: [
        urlMixin,
        priceFlairMixin,
        servicesFlairMixin,
        categoryFlairMixin,
        featuresFlairMixin,
        extraContentFlairsMixin,
        seoUrl,
        photoMixin,
        userMixin,
        xtrackingMixin,
        lazyLoadImg,
    ],
    mounted,
    computed: {
        ...mapState([
            'translate',
            'location',
            'regionData',
            'price',
            'features',
            'settings',
            'services',
            'category',
            'extraContent',
            'priceTemp',
            'featuresTemp',
            'servicesTemp',
            'categoryTemp',
            'extraContentTemp',
            'searchResponse',
            'allServices',
            'locationTemp',
            'searchScrollPosition',
            'searchRadius',
            'searchRadiusTemp',
            'similarEscorts',
            'venue',
            'asia',
            'hideExplicitRegionAds',
            'showStoriesCookieSet',
            'regionData',
        ]),
        hasActiveFilters() {
            return this.store.getters.hasActiveFilters;
        },
        users() {
            const users = _.cloneDeep(this.searchResponse.users) || [];

            if (
                _.get(this.solAds, 'length', 0) ||
                _.get(this.susiLive, 'length', 0) ||
                _.get(this.stripChat, 'length', 0) ||
                this.searchResponse.current_page === 1
            ) {
                const solads = _.cloneDeep(this.solAds);
                const stripChats = _.cloneDeep(this.stripChat);
                const susiLives = _.cloneDeep(this.susiLive);

                const colours = ['red', 'green', 'gold'];

                users.forEach((user, index) => {
                    if (user.isSolAd) {
                        let solad = solads.pop();

                        /**
                         * Fallback: if solad API didn't return data, create placeholder.
                         * Uses default image (isDefault: true) merged with slot metadata.
                         * Note: real ads from API include advertSize property needed for styling.
                         */
                        if (!solad) {
                            solad = {...this.getDefaultPlaceholderForAds(), ...user};
                        }

                        solad.isSolAd = true;
                        solad.color = _.first(colours.splice((Math.random() * colours.length) | 0, 1));

                        users[index] = solad;
                    }

                    if (user.isNativeAd) {
                        user.adTagColor = _.sample(['red', 'green', 'gold']);
                    }

                    if (user.isSusiLive) {
                        let susiLive = susiLives.pop();

                        if (!susiLive) {
                            susiLive = this.getDefaultPlaceholderForAds();
                        }

                        susiLive.isSusiLive = true;

                        users[index] = susiLive;
                    }

                    if (user.isStripChat) {
                        let stripChat = stripChats.pop();

                        if (!stripChat) {
                            stripChat = this.getDefaultPlaceholderForAds();
                        }

                        stripChat.isStripChat = true;

                        users[index] = stripChat;
                    }
                })

            }

            return users;
        },
        renderObjectsList() {
            const users = this.users;
            if (!users || !users.length) {
                return [];
            }

            advertSlots.prepareSlots();
            advertSlots.setInterstitialCmsAdverts(_.cloneDeep(_.get(this.location, 'adverts', [])));
            advertSlots.setHardcodedAdverts(_.clone(_.get(this, 'hardcodedAdverts', [])));

            const searchId = _.get(this, 'searchResponse.request.id', null);

            let renderingObject = [];
            users.forEach((user, index) => {
                user.position = index + 1;
                user.searchId = searchId;

                renderingObject.push(user);

                advertSlots.searchSlotsTaken++;
                if (this.isGoldUser(user)) {
                    advertSlots.searchSlotsTaken++; // premiums take 2 slots
                }

                if (this.isVipPunter) {
                    return;
                }

                if (advertSlots.interstitialCmsAdvertsSlotsTaken >= advertSlots.interstitialCmsAdvertsSlotCount) {
                    return;
                }

                if (this.searchResponse.current_page === 1 && !this.hideExplicitRegionAds) {
                    renderingObject = advertSlots.insertFirstPageAdvert(renderingObject)

                    /** we return early for first page adverts because we don't need to calculate next adverts */
                    return;
                }

                if (advertSlots.hardcodedAdvertSlotsTaken >= advertSlots.hardcodedAdvertsSlotCount) {
                    return;
                }

                if (this.searchResponse.current_page !== 1 && !this.hideExplicitRegionAds) {
                    renderingObject = advertSlots.insertOtherThenFirstPageAdvert(renderingObject)
                }
            })

            return renderingObject;
        },
    },
    watch: {
        categoryTemp: function () {
            this.fetchTmpCountDebounced();
        },
        servicesTemp: function () {
            this.fetchTmpCountDebounced();
        },
        priceTemp: function () {
            this.fetchTmpCountDebounced();
        },
        featuresTemp: function () {
            this.fetchTmpCountDebounced();
        },
        locationTemp: function () {
            this.fetchTmpCountDebounced();
        },
        searchRadiusTemp: function () {
            this.fetchTmpCountDebounced();
        },
        extraContentTemp: function () {
            this.fetchTmpCountDebounced();
        },
        loading(value) {
            if (value === false) {
                this.$nextTick(jQueryLogic);
                this.initLazyLoading();
                this.$nextTick(() => {
                    if (this.searchScrollPosition) {
                        window.scrollTo(this.searchScrollPosition.x, this.searchScrollPosition.y);
                    }
                });
            }
        },
        allServices(value) {
            if (value && value.length) {
                this.stopLoading();
            }
        },
    },
    beforeDestroy() {
        if (this.unSubscribe) {
            this.unSubscribe();
        }
        this.store.commit('setSearchResponse', {
            users: null,
            total: null,
            current_page: 1,
            last_page: 1,
            request: null,
        });
        window.removeEventListener('popstate', this.onURLChange);
    },
    components: {
        IconComponent,
        ModalPunterLoginOrRegisterComponent,
        'saved-search-new-escorts-component': SavedSearchNewEscortsComponent,
        'similar-escorts-component': SimilarEscortsComponent,
        'regular-escort-component': RegularEscortViewComponent,
        'premium-escort-component': PremiumEscortViewComponent,
        'modal-save-search': ModalSaveSearchResultsComponent,
        'advert-in-search-component': AdvertsInSearchComponent,
        'solad-in-search-component': SoladInSearchComponent,
        'native-ad-in-search-component': NativeAdInSearchComponent,
        'visitx-in-search-component': VisitxInSearchComponent,
        'strip-chat-in-search-component': StripChatSearchComponent,
        'susi-live-in-search-component': SusiLiveSearchComponent,
        'toggle-gallery-filter': TogglePrivateGalleryFilterComponent,
        'toggle-gender-filter': ToggleGenderFilterComponent,
        ToggleSexChatFilterComponent,
        HardcodedAdvertsInSearchComponent,
        PaginationComponent,
    },
    methods: {
        fa_angle_down,
        fa_bell,
        getData,
        formatResultsTotal,
        fetchTmpCountDebounced,
        filterOpened,
        onFailure,
        showResults,
        cancelFilters,
        calculateDistanceToUser,
        onDistanceClick,
        getCurrentLocation,
        updateUserDistance,
        onLocationError,
        clearAllFilters,
        clearAllFiltersAndRefresh,
        onGenderFilterChanged,
        defineSortBy,
        onURLChange,
        fetchCurrentLocationData,
        stopLoading,
        changePage,
        setLocalStorage,
        trackSearchSate,
        defaultGenderPayloadCallback,
        saveSearch,
        fetchSearchStories,
        fetchSolAds,
        fetchSusiLive,
        fetchStripChat,
        getDefaultPlaceholderForAds,
        modifyRegionHardcodedAdverts,
        getFirstItemWithCount,
    },
};
</script>
